import { action, observable } from "mobx";

class AIAgentStore {
  @observable isOpen = false;
  @observable messages = [];
  @observable pendingQuery = null;
  @observable context = {
    url: window.location.href,
    title: document.title
  };

  @action
  toggle = () => {
    this.isOpen = !this.isOpen;
  };

  @action
  setIsOpen = (value) => {
    this.isOpen = value;
  };

  @action
  addMessage = (msg) => {
    this.messages.push(msg);
  };

  // Opens the panel and seeds an initial user query. AIAgentPanel observes
  // pendingQuery, fires the chat once, and clears it via consumePendingQuery.
  @action
  askWithQuery = (query) => {
    if (!query || !query.trim()) return;
    this.isOpen = true;
    this.pendingQuery = query.trim();
  };

  @action
  consumePendingQuery = () => {
    const q = this.pendingQuery;
    this.pendingQuery = null;
    return q;
  };

  @action
  setContext = (location) => {
    this.context = {
      url: window.location.href,
      title: document.title,
      pathname: location?.pathname
    };
  };
}

export const aiAgentStore = new AIAgentStore();
export default aiAgentStore;
